import * as PropTypes from 'prop-types';
export var elementType = PropTypes.elementType;
export var disabled = Object.assign(function () {
  return PropTypes.bool.apply(PropTypes, arguments);
}, {
  acceptsArray: PropTypes.oneOfType([PropTypes.bool, PropTypes.array])
});
export var accessor = PropTypes.oneOfType([PropTypes.string, PropTypes.func]);
export var message = PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.func]);